import { COOKIE_ROLE_NAME } from "constants/common";
import { CompanySection, UserRole } from "modules/auth";
import {
  useGetCurrentCompany,
  useGetCurrentManagerProfile
} from "modules/companyAdminAuth";
import { useCookies } from "react-cookie";

const ALL_SECTIONS: CompanySection[] = [
  CompanySection.Dashboard,
  CompanySection.Orders,
  CompanySection.Drivers,
  CompanySection.StaffManagement,
  CompanySection.CompanySettings
];

const useCurrentPortalUser = () => {
  const [cookies] = useCookies();
  const role = cookies[COOKIE_ROLE_NAME] as UserRole | undefined;

  const isManager = role === UserRole.CompanyManager;

  const companyQuery = useGetCurrentCompany({ enabled: !isManager });
  const managerQuery = useGetCurrentManagerProfile({ enabled: isManager });

  if (isManager) {
    return {
      role,
      company: managerQuery.company,
      manager: managerQuery.manager,
      allowedSections: managerQuery.manager?.allowedSections ?? [],
      isLoading: managerQuery.isLoading,
      isError: managerQuery.isError
    };
  }

  return {
    role,
    company: companyQuery.company,
    manager: undefined,
    allowedSections: ALL_SECTIONS,
    isLoading: companyQuery.isLoading,
    isError: companyQuery.isError
  };
};

export default useCurrentPortalUser;
